import React from 'react'
import { Link } from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image'

import {
  EuiSpacer,
  EuiCard,
  EuiFlexGroup,
  EuiFlexItem
} from '@elastic/eui'


export default function LatestArticle() {

  return (
    <React.Fragment>
      <EuiFlexItem>
        <EuiFlexGroup gutterSize="l" direction="row" style={{margin: '0 7px'}} >
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/1080p_Series_CGI_List/Multimedia_Menu/Audio/">
                  <StaticImage
                    src='../../../images/1080p_Series_CGI_List/Multimedia_Menu/1080pCGIs-WebUI_Multimedia_Audio.webp'
                    alt="1080p Serie CGI List - Multimedia Menu"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                    />
                </Link>
              }
              title="Audio"
            />
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/1080p_Series_CGI_List/Multimedia_Menu/Video/">
                  <StaticImage
                    src='../../../images/1080p_Series_CGI_List/Multimedia_Menu/1080pCGIs-WebUI_Multimedia_Video.webp'
                    alt="1080p Serie CGI List - Multimedia Menu"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                    />
                </Link>
              }
              title="Video"
            />
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/1080p_Series_CGI_List/Multimedia_Menu/Image/">
                  <StaticImage
                    src='../../../images/1080p_Series_CGI_List/Multimedia_Menu/1080pCGIs-WebUI_Multimedia_Image.webp'
                    alt="1080p Serie CGI List - Multimedia Menu"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                    />
                </Link>
              }
              title="Image"
            />
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>

      <EuiSpacer />

      <EuiFlexItem>
        <EuiFlexGroup gutterSize="l" direction="row" style={{margin: '0 7px'}} >
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/1080p_Series_CGI_List/Multimedia_Menu/Overlays/">
                  <StaticImage
                    src='../../../images/1080p_Series_CGI_List/Multimedia_Menu/1080pCGIs-WebUI_Multimedia_Overlays.webp'
                    alt="1080p Serie CGI List - Multimedia Menu"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                    />
                </Link>
              }
              title="Overlays"
            />
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/1080p_Series_CGI_List/Multimedia_Menu/Privacy_Mask/">
                  <StaticImage
                    src='../../../images/1080p_Series_CGI_List/Multimedia_Menu/1080pCGIs-WebUI_Multimedia_Privacy.webp'
                    alt="1080p Serie CGI List - Multimedia Menu"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                    />
                </Link>
              }
              title="Privacy Mask"
            />
          </EuiFlexItem>
          <EuiFlexItem>
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>
    </React.Fragment>
  );
}
